/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { excludedTeamSummarySchema } from './excludedTeamSummarySchema';
import { integrationFieldMappingsSchema } from './integrationFieldMappingsSchema';
import { integrationFiltersSchema } from './integrationFiltersSchema';

export const integrationSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  credentialsId: z.int().nullish(),
  deletionRetryCount: z.int(),
  displayName: z.string(),
  excludedTeamCount: z.int(),
  get excludedTeams() {
    return z.array(excludedTeamSummarySchema);
  },
  get fieldMapping() {
    return integrationFieldMappingsSchema;
  },
  fieldMappingsUpdatedAt: z.iso.datetime().nullish(),
  get filters() {
    return integrationFiltersSchema;
  },
  hasMappingChangeSinceLastPull: z.boolean(),
  id: z.int(),
  instanceId: z.string(),
  instanceUrl: z.string(),
  integrationInstanceId: z.int(),
  isLastPullFullSync: z.boolean().nullish(),
  isLastPushFullSync: z.boolean().nullish(),
  lastPullAttemptAt: z.iso
    .datetime()
    .describe(
      'End time of the latest finished pull sync, whatever its outcome (unlike lastPullSyncAt).',
    )
    .nullish(),
  lastPullAttemptStatus: z
    .enum([
      'CREATED',
      'QUEUED',
      'RUNNING',
      'COMPLETED',
      'COMPLETED_WITH_PENDING',
      'PARTIAL_FAILURE',
      'FAILED',
    ])
    .nullish(),
  lastPulledBy: z.string().nullish(),
  lastPullSyncAt: z.iso.datetime().nullish(),
  lastPushAttemptAt: z.iso
    .datetime()
    .describe(
      'End time of the latest finished push sync, whatever its outcome (unlike lastPushSyncAt).',
    )
    .nullish(),
  lastPushAttemptStatus: z
    .enum([
      'CREATED',
      'QUEUED',
      'RUNNING',
      'COMPLETED',
      'COMPLETED_WITH_PENDING',
      'PARTIAL_FAILURE',
      'FAILED',
    ])
    .nullish(),
  lastPushedBy: z.string().nullish(),
  lastPushSyncAt: z.iso.datetime().nullish(),
  loopId: z.int(),
  name: z.string().nullish(),
  organizationId: z.string(),
  projectId: z.string(),
  pushRankSyncEnabled: z.boolean(),
  skipDescription: z.boolean().nullish(),
  sourceOrgId: z.string().nullish(),
  sourceSystemType: z.enum(['JIRA', 'ADO']),
  status: z.enum([
    'CREATED',
    'QUEUED',
    'RUNNING',
    'COMPLETED',
    'COMPLETED_WITH_PENDING',
    'PARTIAL_FAILURE',
    'FAILED',
  ]),
  synchronizationStatus: z.enum(['ENABLED', 'DISABLED', 'DELETING']),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
